import {Component, Input} from '@angular/core';
import {Message} from '../models/message';

@Component({
    selector: 'app-message-thread',
    templateUrl: './message-thread.component.html',
    styleUrls: ['./message-thread.component.scss'],
    standalone: false
})
export class MessageThreadComponent {
    @Input() messages: Message[];
    @Input() companionName: string;

    constructor() {
    }

}
